import { IUserName } from 'APIPackage/KnmSearchModule/interfaces/IUserName';

export const getFullName = ({ firstName, surname, middleName }: IUserName) => {
  let fullName = '';

  const names = [surname, firstName, middleName];

  names.forEach((name, index) => {
    if (name != null && name.length > 0) {
      if (index === 0) {
        fullName = fullName.concat(name);

        return;
      }
      fullName = fullName.concat(` ${name}`);
    }
  });

  return fullName;
};
